import React from 'react';

const StartOverlay = ({ onStart }) => {
    return (
        <div style={{
            position: 'fixed',
            top: 0, left: 0, right: 0, bottom: 0,
            backgroundColor: 'rgba(15, 17, 21, 0.95)',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 1000,
            backdropFilter: 'blur(10px)'
        }}>
            <h1 style={{
                color: '#fff',
                marginBottom: '20px',
                fontSize: '2rem',
                letterSpacing: '0.1em'
            }}>
                MIDISeek <span style={{ color: 'var(--color-primary)' }}>REACT</span>
            </h1>

            <button
                onClick={onStart}
                style={{
                    padding: '20px 40px',
                    fontSize: '1.5rem',
                    backgroundColor: 'var(--color-primary)',
                    color: '#000',
                    border: 'none',
                    borderRadius: '8px',
                    cursor: 'pointer',
                    boxShadow: '0 0 20px rgba(0, 229, 255, 0.5)',
                    fontWeight: 'bold'
                }}
            >
                START AUDIO ENGINE
            </button>

            <p style={{ marginTop: '20px', color: 'var(--text-muted)' }}>
                Click to initialize Tone.js
            </p>
        </div>
    );
};

export default StartOverlay;
